export const getPagesInputs = (initialValues) => [
    {
      type: "TEXT",
      label: "Title",
      id: "title",
      name: "title",
      value: initialValues?.title || "",
      placeholder: "Enter the Title",
      validations: [
        {
          type: "REQUIRED",
          message: "Title is required !",
        },
      ],
    },
    {
      type: "TEXT_AREA",
      label: "Meta Data",
      id: "meta_data",
      name: "meta_data",
      value: initialValues?.meta_data || "",
      placeholder: "Enter the Meta Data",
      validations: [
        {
          type: "REQUIRED",
          message: "Meta Data is required !",
        },
      ],
    },
    {
      type: "TEXT",
      label: "Slug",
      id: "slug",
      name: "slug",
      value: initialValues?.slug || "",
      placeholder: "Enter the Slug",
      validations: [
        {
          type: "REQUIRED",
          message: "Slug is required !",
        },
      ],
    },
    {
      type: "TEXT_AREA",
      label: "Content",
      id: "content",
      name: "content",
      value: initialValues?.content || "",
      placeholder: "Enter the Content",
      validations: [
        {
          type: "REQUIRED",
          message: "Content is required !",
        },
      ],
    },
  ];
  